import {TimelineByDateChartData} from 'entities/chartData';
import {AnyBaseEventWithChannel} from 'entities/event';


export enum SearchType {
    Default = 'default',
}

export interface RegularSearchResultEvent extends AnyBaseEventWithChannel {
    event_highlight_text?: string;
}

export type SearchResultEvent = RegularSearchResultEvent;

export interface SearchResult {
    searchResult: SearchResultEvent[];
    searchResultCount: number;
    pagesList: number[];
    searchData: TimelineByDateChartData[];
    searchType: SearchType;
    queryDuration: string;
}
